import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import Datepicker from "react-tailwindcss-datepicker";
import Select from "react-select";
import locationIconSvg from "../../assets/images/location-icon.svg";
import * as Yup from "yup";
import {
  getNumberOfDays,
  getNumberOfDaysForNormalDays,
  langoptions,
  orderBookingCampaignTypes,
  slotBookingCreativeTypes,
  slotPositions,
} from "../../utils/constants";
import api from "../../services/api";
import { useNavigate } from "react-router";
import config from "../../config";
import { formatDateYYYYMMDD } from "../../utils/dateFormat";

let languageOptions = langoptions;
let positionOptions = slotPositions.map((item) => {
  return { label: item === -1 ? "SOV" : item, value: item };
});
let slotOptions = [
  { label: "A", value: 0 },
  { label: "B", value: 1 },
];
export let subFormInitialValues = {
  lang_ids: [],
  state_ids: [],
  district_ids: [],
  mandal_ids: [],
  constituency_ids: [],
  date_ranges: [{ startDate: "", endDate: "" }],
  positions: [],
  slot: 0,
  creative_type: "",
  campaign_type: "",
  sales_price: 0,
  adunit_budget: 0,
  quantity:0,
  internal_id: 0,
};
function OrderDetails(props) {
  let {
    formikB,
    index,
    nextClicked,
    saveChanges,
    new_user_type,
    editData,
    formikBSubFormValues,
    setFormikBSubFormValues,
    formikBSubFormErrors,
    setFormikBSubFormErrors,
    key,
  } = props;
  const navigate = useNavigate();
  const [daysMismatched, setDaysMismatched] = useState(false);
  const [stateOptions, setStateOptions] = useState([]);
  const [districtOptions, setDistrictOptions] = useState([]);
  const [mandalOptions, setMandalOptions] = useState([]);
  const [constituencyOptions, setConstituencyOptions] = useState([]);
  const [initialRender, setInitialRender] = useState(true);
  // Custom validation to check for overlap
  const validateNoOverlap = (value, context) => {
    const allRanges = context.parent; // Access the full array
    const currentIndex = context.options.index; // Current item's index

    // Convert startDate and endDate to timestamps
    const valueStart = Math.floor(new Date(value.startDate).getTime() / 1000);
    const valueEnd = Math.floor(new Date(value.endDate).getTime() / 1000);

    for (let i = 0; i < allRanges.length; i++) {
      if (i !== currentIndex) {
        const range = allRanges[i];
        const rangeStart = Math.floor(
          new Date(range.startDate).getTime() / 1000
        );
        const rangeEnd = Math.floor(new Date(range.endDate).getTime() / 1000);

        if (
          (rangeStart <= valueStart && valueStart <= rangeEnd) || // Overlap start
          (rangeStart <= valueEnd && valueEnd <= rangeEnd) || // Overlap end
          (valueStart <= rangeStart && rangeStart <= valueEnd) || // Enclosing range
          (valueStart <= rangeEnd && rangeEnd <= valueEnd) // Enclosing range
        ) {
          return false; // Overlap detected
        }
      }
    }
    return true; // No overlap
  };
  const getvalues = (Array, field) => {
    if (Array.length > 0) {
      switch (field) {
        case "lang_ids":
          return Array.filter(
            (option) => formik.values.lang_ids?.indexOf(option.value) >= 0
          );
        case "state_ids":
          let fun = [];
          formik.values.state_ids?.map((option) => {
            fun.push(option.state_id);
            return null;
          });
          return Array.filter(
            (option) => fun.indexOf(option.value.state_id) >= 0
          );
        case "district_ids":
          const res1 = [];
          formik.values.district_ids?.map((option) => {
            res1.push(option.dist_id);
            return null;
          });
          return Array.filter(
            (option) => res1.indexOf(option.value.dist_id) >= 0
          );

        case "mandal_ids":
          const res2 = [];
          formik.values.mandal_ids?.map((option) => {
            res2.push(option.mandal_id);
            return null;
          });
          return Array.filter(
            (option) => res2.indexOf(option.value.mandal_id) >= 0
          );
        case "village_ids":
          const res3 = [];
          formik.values.village_ids?.map((option) => {
            res3.push(option.village_id);
            return null;
          });
          return Array.filter(
            (option) => res3.indexOf(option.value.village_id) >= 0
          );
        case "constituency_ids":
          const res4 = [];
          formik.values.constituency_ids?.map((option) => {
            res4.push(option.const_id);
            return null;
          });
          return Array.filter(
            (option) => res4.indexOf(option.value.const_id) >= 0
          );
        // case "pincodes":
        // return Array.filter((option) => formik.values.pincodes.indexOf(option.value) >= 0)
        case "positions":
          return Array.filter(
            (option) => formik.values.positions?.indexOf(option.value) >= 0
          );
        default:
          return [];
      }
    } else {
      return [];
    }
  };
  const defaultValue = (options, value) => {
    return options
      ? options.find((option) => option.value === value) || null
      : null;
  };
  const onchange = (selected, field) => {
    formik.setFieldValue(
      field,
      selected ? selected.map((item) => item.value) : []
    );
  };

  const formik = useFormik({
    initialValues: subFormInitialValues,
    validationSchema: Yup.object({
      lang_ids: Yup.array()
        .required("Language is required")
        .min(1, "Please select atleast one language"),
      state_ids: Yup.array(),
      district_ids: Yup.array(),
      mandal_ids: Yup.array(),
      constituency_ids: Yup.array(),
      date_ranges: Yup.array()
        .of(
          Yup.object()
            .shape({
              startDate: Yup.date()
                .required("Required")
                .typeError("Invalid Start date"),
              endDate: Yup.date()
                .required("End date is required")
                .typeError("Invalid End date")
                .min(
                  Yup.ref("startDate"),
                  "End date must be after the start date"
                ),
            })
            .test("no-overlap", "Date ranges cannot overlap", function (value) {
              const context = this; // Pass the Yup context to the validation function
              return validateNoOverlap(value, context);
            })
        )
        .required("At least one date range is required")
        .min(1, "You must provide at least one date range"),
      positions: Yup.array().when("campaign_type", {
        is: (value) => value === "CPD",
        then: Yup.array()
          .required("positions is required")
          .min(1, "Please select atleast one positions"),
        otherwise: Yup.array(),
      }),

      //   position: Yup.number("Position is Required").required(
      //     "Position is Required"
      //   ),
      slot: Yup.number("Slot is Required").required("Slot is required"),
      creative_type: Yup.string().when('campaign_type', {
        is: (val) => ['CPD', 'CPM', 'CPC'].includes(val),
        then: (schema) => schema.required('Creative Type is required'),
        otherwise: (schema) => schema.notRequired(),
      }),      
      campaign_type: Yup.string().required("Campaign Type is Required"),
      sales_price: Yup.number()
        .min(1, "Price Required")
        .required("Price is Required"),
      adunit_budget: Yup.number()
        .min(1, "Price Required")
        .required("Price is Required"),
    }),
    onSubmit: async (values) => {},
  });

  useEffect(() => {
    if (
      new_user_type === 5 &&
      formik.values.package_no &&
      formik.values?.date_ranges?.length &&
      formik.values.campaign_type === "CPD"
    ) {
      let date_ranges = formik.values.date_ranges
        .map((item) => {
          let start_date = new Date(`${item.startDate}T00:00:00+05:30`); // Create a Date object in your local timezone
          let end_date = new Date(`${item.endDate}T00:00:00+05:30`); // Create a Date object in your local timezone
          start_date = Math.floor(new Date(start_date).getTime() / 1000);
          end_date.setHours(23, 59, 59, 59);
          end_date = Math.floor(new Date(end_date).getTime() / 1000);
          return { start_date, end_date };
        })
        .sort((a, b) => a.start_date - b.start_date);
      let noOfDays = getNumberOfDays(date_ranges);
      let package_no = formik.values.package_no;
      switch (+package_no) {
        case 1:
          setDaysMismatched(false);
          break;
        case 2:
          if (noOfDays < 4) setDaysMismatched(true);
          else setDaysMismatched(false);
          break;
        case 3:
          if (noOfDays < 5) setDaysMismatched(true);
          else setDaysMismatched(false);
          break;
        case 4:
          if (noOfDays < 7) setDaysMismatched(true);
          else setDaysMismatched(false);
          break;
        case 5:
          if (noOfDays < 30) setDaysMismatched(true);
          else setDaysMismatched(false);
          break;
        default:
          setDaysMismatched(false);
      }
    } else {
      setDaysMismatched(false);
    }
  }, [
    new_user_type,
    formik.values.package_no,
    formik.values.date_ranges,
    formik.values.campaign_type,
  ]);
  const editAction = async (editItem) => {
    if (editItem) {
      let {
        date_ranges,
        lang_ids,
        state_ids,
        district_ids,
        constituency_ids,
        mandal_ids,
        positions,
        slot,
        creative_type,
        campaign_type,
        sales_price,
        adunit_budget,
        internal_id,
        quantity
      } = editItem;
      if (date_ranges.length) {
        date_ranges = date_ranges.map((item) => {
          return normalizeDateRange({
            startDate: item.start_date || item.startDate,
            endDate: item.end_date || item.endDate,
          });
        });
        formik.setFieldValue("date_ranges", date_ranges);
      }
     
      formik.setFieldValue("creative_type", creative_type);
      formik.setFieldValue("campaign_type", campaign_type);
      formik.setFieldValue("sales_price", sales_price);
      formik.setFieldValue("quantity", quantity ?  quantity : Math.round(adunit_budget / sales_price) );
      formik.setFieldValue("internal_id", internal_id);
      onchange(
        positionOptions.filter((item) => positions.includes(item.value)),
        "positions"
      );
      formik.setFieldValue("slot", slot);
      formik.setFieldValue("lang_ids", lang_ids);

      if(langoptions.length > 0){
        const lang_values = getSelectValues(langoptions, 'lang_ids', lang_ids);
        onchange(lang_values,"lang_ids");
          let states = await lang_idsOnchange(lang_values )
          // After states are loaded, set state values
          if (states.length > 0) {
            const stateValues = getSelectValues(states, 'state_ids', state_ids);
            onchange( stateValues,"state_ids");
            
            // Load districts and wait for completion
            let dists = await state_idsOnchange(stateValues, lang_ids);
            // After districts are loaded, set district values
            if (dists.length > 0) {
              district_ids = district_ids.map(id => +id)
              const districtValues = getSelectValues(dists, 'district_ids', district_ids);
              onchange(districtValues,"district_ids" );
              
              // Load constituencies and wait for completion
              let consts = await district_idsOnchange(districtValues, lang_ids);
              
              // After constituencies are loaded, set constituency values
              if (consts.length > 0) {
                const constituencyValues = getSelectValues(consts, 'constituency_ids', constituency_ids);
                onchange(constituencyValues,"constituency_ids");
              }
            }
          }
          }
      formik.setFieldValue("adunit_budget", adunit_budget);
         
    }
    setInitialRender(false);
  };

  useEffect(() => {
    // if (editData) {
    //   console.log("editData", editData);
    editAction(editData);
    // }
  }, []);

  useEffect(() => {
    if (
        ["Magazines", "Stories", "CPD"].includes(formik.values.campaign_type)  &&
        formik.values.sales_price && formik.values.quantity &&
        !initialRender
      ) {
        formik.setFieldValue(
          "adunit_budget",
          +formik.values.sales_price
            ? +formik.values.sales_price *
            formik.values.quantity 
            : 0
        );
      }
  }, [formik.values.date_ranges, formik.values.sales_price, formik.values.quantity]);

  //   useEffect(() => {}, [formik.values, formik.errors]);
  useEffect(() => {
    if (!initialRender) {
      formik.setFieldTouched("lang_ids", true);
      formik.setFieldTouched(
        "date_ranges",
        formik.values.date_ranges.map((item) => {
          return { startDate: true, endDate: true };
        })
      );
      formik.setFieldTouched("positions", true);
      formik.setFieldTouched("slot", true);
      formik.setFieldTouched("creative_type", true);
      formik.setFieldTouched("campaign_type", true);
      formik.setFieldTouched("sales_price", true);
      formik.setFieldTouched("adunit_budget", true);
    }
  }, [nextClicked]);

  useEffect(() => {
    if (!initialRender) {
      let tempAllFormValues = formikBSubFormValues,
        tempAllFormErrors = formikBSubFormErrors;
      tempAllFormValues[index] = formik.values;
      tempAllFormErrors[index] = formik.errors;
      setFormikBSubFormValues(tempAllFormValues);
      setFormikBSubFormErrors(tempAllFormErrors);
    }
  }, [saveChanges, formik.values.adunit_budget]);

  const lang_idsOnchange = async (selected) => {
    const langs = selected ? selected.map((item) => item.value) : [];
    try {
      let res = await api({
        url: "/location/getStatesByLangId",
        method: "POST",
        responseType: "json",
        data: langs,
      });
      let states = [];
      for await (let item of res.data) {
        const temp = { value: item, label: `${item.state_name}` };
        states.push(temp);
      }
      setStateOptions(states);
      formik.setFieldValue(
        "state_ids",
        formik.values.state_ids.filter(
          (option) => langs.indexOf(option.lang_id) >= 0
        )
      );
      formik.setFieldValue(
        "district_ids",
        formik.values.district_ids.filter(
          (option) => langs.indexOf(option.lang_id) >= 0
        )
      );
      formik.setFieldValue(
        "constituency_ids",
        formik.values.constituency_ids.filter(
          (option) => langs.indexOf(option.lang_id) >= 0
        )
      );
      formik.setFieldValue(
        "mandal_ids",
        formik.values.mandal_ids.filter(
          (option) => langs.indexOf(option.lang_id) >= 0
        )
      );
      return states
    } catch (error) {
      console.error(error);
      if (error.response?.status === 401) navigate("/");
    }
  };

  const state_idsOnchange = async (selected, langs) => {
    const states = selected
      ? selected.map((item) => {
          if (item.value) return item.value.state_id;
        })
      : [];
    // const langs = formik.values.lang_ids
    try {
      let res = await api({
        url: "/location/getDistrictsByStateId",
        method: "POST",
        responseType: "json",
        data: { states, langs },
      });
      let districts = [];
      for await (let item of res.data) {
        const temp = { value: item, label: `${item.dist_name}` };
        districts.push(temp);
      }
      setDistrictOptions(districts);
      let temp = [];
      await formik.setFieldValue(
        "district_ids",
        formik.values.district_ids.filter((option) => {
          if (states.indexOf(option.state_id) >= 0) {
            temp.push(option.dist_id);
            return true;
          }
        })
      );
      formik.setFieldValue(
        "constituency_ids",
        formik.values.constituency_ids.filter(
          (option) => temp.indexOf(parseInt(option.dist_id)) >= 0
        )
      );
      formik.setFieldValue(
        "mandal_ids",
        formik.values.mandal_ids.filter(
          (option) => temp.indexOf(parseInt(option.dist_id)) >= 0
        )
      );
      return districts;
    } catch (error) {
      console.error(error);
      if (error.response.status === 401) navigate("/");
    }
  };
  const district_idsOnchange = async (selected, langs) => {
    const districts = selected
      ? selected.map((item) => {
          if (item.value) return item.value.dist_id;
        })
      : [];
    try {
      let res = await api({
        url: "/location/getMandalsnew",
        method: "POST",
        responseType: "json",
        data: { districts, langs },
      });
      let mandals = [];
      for await (let item of res.data) {
        const temp = { value: item, label: `${item.mandal_name}` };
        mandals.push(temp);
      }
      setMandalOptions(mandals);
      let consties = await api({
        url: `/location/getConstituentsnew`,
        method: "POST",
        responseType: "json",
        data: { districts, langs },
      });
      let constituents = [];
      for await (let item of consties.data) {
        const temp = { value: item, label: `${item.const_name}` };
        constituents.push(temp);
      }
      setConstituencyOptions(constituents);
      formik.setFieldValue(
        "constituency_ids",
        formik.values.constituency_ids.filter(
          (option) => districts.indexOf(parseInt(option.dist_id)) >= 0
        )
      );
      formik.setFieldValue(
        "mandal_ids",
        formik.values.mandal_ids.filter(
          (option) => districts.indexOf(parseInt(option.dist_id)) >= 0
        )
      );
      return constituents;
    } catch (error) {
      console.error(error);
      if (error.response.status === 401) navigate("/");
    }
  };
  const normalizeDateRange = ({ startDate, endDate }) => {
    const isUnixTimestamp = (val) => typeof val === 'number' && val > 1000000000; // rough check
    const formatToDateString = (dateInput) => {
      // If already a string like "2025-11-24", just return it
      if (typeof dateInput === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dateInput)) {
        return dateInput;
      }
  
      // If Unix timestamp (seconds)
      if (isUnixTimestamp(dateInput)) {
        const date = new Date(dateInput * 1000);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      }
  
      // Fallback: try to parse anyway
      const date = new Date(dateInput);
      if (!isNaN(date.getTime())) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      }
  
      return dateInput; // return original if can't parse
    };
   
    return {
      startDate: formatToDateString(startDate),
      endDate:   formatToDateString(endDate)
    };
  }
  const mandal_idsOnchange = async (
    selected,
    districts,
    langs,
    constituency_ids
  ) => {
    const mandals = selected
      ? selected.map((item) => {
          if (item.value) return item.value.mandal_id;
        })
      : [];
    try {
      //Remove constituency which all mandals are not selected
      if (constituency_ids) {
        const constmandals = mandalOptions.filter((item) =>
          formik.values.constituency_ids
            .map((item) => +item.const_id)
            .includes(item.value.const_id)
        );
        let toRemove_consties = constmandals
          .filter(
            (item) =>
              !selected
                .map((sitem) => +sitem.value.mandal_id)
                .includes(item.value.mandal_id)
          )
          .map((item) => item.value.const_id);
        formik.setFieldValue(
          "constituency_ids",
          constituency_ids.filter(
            (item) => !toRemove_consties.includes(item.const_id)
          )
        );
      }
      let res = await api({
        url: "/location/getVillagesnew",
        method: "POST",
        responseType: "json",
        data: { mandals, langs, districts },
      });
      let villages = [];
      for await (let item of res.data) {
        const temp = { value: item, label: `${item.village}` };
        villages.push(temp);
      }
    } catch (error) {
      console.error(error);
      if (error.response.status === 401) navigate("/");
    }
  };
  const constituency_idsOnchange = async (selected) => {
    if (
      !formik.values.lang_ids.filter((item) => item === 1 || item === 2).length
    ) {
      formik.setFieldValue("mandals", []);
      formik.setFieldValue("constituency_ids", []);
      setConstituencyOptions([]);
    }
    const consties = selected
      ? selected.map((item) => {
          if (item.value) return +item.value.const_id;
        })
      : [];
    const langs = selected
      ? selected.map((item) => {
          if (item.value) return +item.value.lang_id;
        })
      : [];
    const formMandals = formik.values.mandal_ids
      .filter(
        (item) =>
          !formik.values.constituency_ids
            .map((item) => +item.const_id)
            .includes(+item.const_id)
      )
      .map((item) => +item.mandal_id);
    let constMandals = mandalOptions
      .filter(
        (item) =>
          consties.includes(+item.value.const_id) ||
          formMandals.includes(+item.value.mandal_id)
      )
      .map((item) => item.value);
    formik.setFieldValue("mandal_ids", constMandals);
  };

  const getSelectValues = (options, field, fieldValue) => {
    if (options.length > 0 && fieldValue && Array.isArray(fieldValue)) {
      switch (field) {
        case "lang_ids":
          // fieldValue is array of strings/numbers
          return options.filter((option) => fieldValue.some(val => val === option.value));
        case "state_ids":
          // fieldValue is array of objects with state_id
          if (fieldValue.length > 0 && typeof fieldValue[0] === 'object') {
            const stateIds = fieldValue.map((option) => option.state_id);
            return options.filter((option) => stateIds.indexOf(option.value?.state_id) >= 0);
          } else {
            // fieldValue is array of objects (direct values)
            return options.filter((option) => fieldValue.some(val => val === option.value?.state_id));
          }
        case "district_ids":
          // fieldValue is array of objects with dist_id
          if (fieldValue.length > 0 && typeof fieldValue[0] === 'object') {
            const districtIds = fieldValue.map((option) => +option.dist_id);
            return options.filter((option) => districtIds.indexOf(option.value?.dist_id) >= 0);
          } else {
            return options.filter((option) => fieldValue.some(val => val === option.value?.dist_id));
          }
        case "constituency_ids":
          // fieldValue is array of objects with const_id
          if (fieldValue.length > 0 && typeof fieldValue[0] === 'object') {
            const constituencyIds = fieldValue.map((option) => option.const_id);
            return options.filter((option) => constituencyIds.indexOf(option.value?.const_id) >= 0);
          } else {
            return options.filter((option) => fieldValue.some(val => val === option.value?.const_id));
          }
        default:
          return [];
      }
    } else {
      return [];
    }
  };

  useEffect(()=>{
    return(()=>{
      formik.resetForm()
    })
  },[])

  return (
    <form>
      <div id="salesOrderSubForm">
        <div className="bookPosition">
          <div className="ind">
            <h6>
              Type of Campaign<span className="text-red-600">*</span>
            </h6>
            <Select
              aria-label="Default select example"
              name="campaign_type"
              placeholder="Select a Type"
              onBlur={formik.handleBlur}
              value={defaultValue(
                orderBookingCampaignTypes,
                formik.values.campaign_type
              )}
              onChange={(selected) => {
                formik.setFieldValue("campaign_type", selected.value);
                formik.setFieldValue("slot", 0);
                if (selected.value === "CPM") {
                  formik.setFieldValue("sales_price", +config.ACTUALCPM);
                  formik.setFieldValue("positions", [0]);
                  formik.setFieldValue("adunit_budget", 0);
                } else {
                  formik.setFieldValue("sales_price", 0);
                  formik.setFieldValue("adunit_budget", 0);
                }
              }}
              options={orderBookingCampaignTypes}
              className="form-field"
              classNamePrefix="select"
            />
            {formik.touched.campaign_type && formik.errors.campaign_type && (
              <span className="text-red-500 text-xs">
                {formik.errors.campaign_type}
              </span>
            )}
          </div>
          {formik.values.date_ranges.map((date_range, index) => (
            <div className="ind">
              <h6>
                Date Range<span className="text-red-600">*</span>
              </h6>
              <div className="d-flex flex-col" key={index}>
                <span className="d-flex gap-1 items-start relative">
                  <span className="w-full border rounded">
                    {/* Date Picker */}
                    <Datepicker
                      onChange={(value) => {
                        const updatedDateRanges = [
                          ...formik.values.date_ranges,
                        ];
                        updatedDateRanges[index] = value; // Set the new value (object with startDate and endDate)
                        formik.setFieldValue("date_ranges", updatedDateRanges);
                      }}
                      name={`date_ranges[${index}]`}
                      onBlur={formik.handleBlur}
                      value={date_range} // Entire object { startDate, endDate }
                      minDate={new Date()} // Optional: Prevent selection of past dates
                      primaryColor={"blue"}
                      disabledDates={formik.values.date_ranges
                        .map((date_range, tempindex) => {
                          if (tempindex !== index) {
                            return {
                              startDate: new Date(
                                date_range.startDate
                              ).setHours(0, 0, 0, 0),
                              endDate: new Date(date_range.endDate).setHours(
                                23,
                                59,
                                59,
                                59
                              ),
                            };
                          }
                        })
                        .filter((item) => item)}
                    />
                  </span>
                  {index !== 0 ? (
                    <div className="col3 text-danger absolute dtrng-cls">
                      <sl-icon
                        library="lucide"
                        name="x-circle"
                        type="button"
                        size="medium"
                        aria-hidden="true"
                        onClick={() => {
                          const newDateRanges = [...formik.values.date_ranges];
                          newDateRanges.splice(index, 1); // Remove the selected date range
                          formik.setFieldValue("date_ranges", newDateRanges);
                        }}
                      ></sl-icon>
                    </div>
                  ) : null}
                  {index === 0 ? (
                    <button
                      type="button"
                      class="btn p-0"
                      onClick={() => {
                        formik.setFieldValue("date_ranges", [
                          ...formik.values.date_ranges,
                          { startDate: "", endDate: "" },
                        ]);
                      }}
                    >
                      <i class="bi bi-plus-circle-fill text-primary fs-4"></i>
                    </button>
                  ) : null}
                </span>
                {/* Error Messages */}
                {formik.touched.date_ranges &&
                  formik.touched.date_ranges[index] &&
                  formik.errors.date_ranges &&
                  formik.errors.date_ranges[index] && (
                    <span className="text-red-500 text-xs">
                      {formik.errors.date_ranges[index]?.startDate
                        ? formik.errors.date_ranges[index]?.startDate
                        : formik.errors.date_ranges[index]}
                    </span>
                  )}
              </div>
            </div>
          ))}
          <div className="ind">
            <h6>
              Language <span className="text-red-600">*</span>
            </h6>
            <Select
              // class="form-select"
              aria-label="Default select example"
              name="lang_ids"
              placeholder="select language"
              onBlur={formik.handleBlur}
              value={getvalues(languageOptions, "lang_ids")}
              onChange={(selected) => {
                onchange(selected, "lang_ids");
                lang_idsOnchange(selected);
              }}
              options={languageOptions}
              isMulti
            />
            {formik.errors.lang_ids && formik.touched.lang_ids ? (
              <span id="formikError" className="text-red-500 text-xs">
                {formik.errors.lang_ids}
              </span>
            ) : null}
          </div>
          <div className="ind">
            <h6>State</h6>
            <Select
              // class="form-select"
              aria-label="Default select example"
              name="states_ids"
              placeholder="Select States"
              onBlur={formik.handleBlur}
              value={getvalues(stateOptions, "state_ids")}
              onChange={(selected) => {
                onchange(selected, "state_ids");
                state_idsOnchange(selected, formik.values.lang_ids);
              }}
              options={stateOptions}
              isMulti
            />
          </div>
          <div className="ind">
            <h6>Districts</h6>
            <Select
              // class="form-select"
              aria-label="Default select example"
              name="district_ids"
              placeholder="Select Districts"
              onBlur={formik.handleBlur}
              value={getvalues(districtOptions, "district_ids")}
              onChange={(selected) => {
                onchange(selected, "district_ids");
                district_idsOnchange(selected, formik.values.lang_ids);
              }}
              options={districtOptions}
              isMulti
            />
          </div>
          {formik.values.lang_ids.filter((item) => item === 1 || item === 2)
            .length ? (
            <div className="ind">
              <h6>Constituency</h6>
              <Select
                // class="form-select"
                aria-label="Default select example"
                name="constituency_ids"
                placeholder="Select Constituency"
                onBlur={formik.handleBlur}
                value={getvalues(constituencyOptions, "constituency_ids")}
                onChange={(selected) => {
                  onchange(selected, "constituency_ids");
                  constituency_idsOnchange(selected);
                }}
                options={constituencyOptions}
                isMulti
              />
            </div>
          ) : null}
          {['CPM', 'CPC', 'CPD'].includes(formik.values.campaign_type) && <div className="ind">
            <h6>
              Creative Type<span className="text-red-600">*</span>
            </h6>
            <Select
              aria-label="Default select example"
              name="creative_type"
              placeholder="Select a Type"
              onBlur={formik.handleBlur}
              value={defaultValue(
                slotBookingCreativeTypes,
                formik.values.creative_type
              )}
              onChange={(selected) => {
                formik.setFieldValue("creative_type", selected.value);
              }}
              options={slotBookingCreativeTypes}
              className="basic-multi-select"
              classNamePrefix="select"
            />
            {formik.touched.creative_type && formik.errors.creative_type && (
              <span id="formikError" className="text-red-500 text-xs">
                {formik.errors.creative_type}
              </span>
            )}
          </div>}
          {formik.values.campaign_type === "CPD" ? (
            <div className="ind">
              <h6>
                Select Position<span className="text-red-600">*</span>
              </h6>
              <Select
                // class="form-select"
                aria-label="Default select example"
                name="positions"
                placeholder="select Positions"
                onBlur={formik.handleBlur}
                value={getvalues(positionOptions, "positions")}
                onChange={(selected) => {
                  onchange(selected, "positions");
                }}
                options={positionOptions}
                isMulti
              />
              {formik.errors.positions && formik.touched.positions ? (
                <span id="formikError" className="text-red-500 text-xs">
                  {formik.errors.positions}
                </span>
              ) : null}
            </div>
          ) : null}
          {formik.values.campaign_type === "CPD" ? (
            <div className="ind">
              <h6>
                Select Slot<span className="text-red-600">*</span>
              </h6>
              <Select
                // class="form-select"
                aria-label="Default select example"
                name="slot"
                placeholder="Select Slot"
                onBlur={formik.handleBlur}
                value={defaultValue(slotOptions, formik.values.slot)}
                onChange={(selected) =>
                  formik.setFieldValue("slot", selected.value)
                }
                options={
                  formik.values.positions.includes(3)
                    ? [{ label: "A", value: 0 }]
                    : slotOptions
                }
                className="basic-multi-select"
                classNamePrefix="select"
              />
              {formik.errors.slot && formik.touched.slot ? (
                <span id="formikError" className="text-red-500 text-xs">
                  {formik.errors.slot}
                </span>
              ) : null}
            </div>
          ) : null}

          <div className="ind">
            <h6>
              {formik.values.campaign_type === "CPD"
                ? "CPD Price"
                : formik.values.campaign_type === "CPM" ? "CPM Price" : formik.values.campaign_type === "CPC" ? "CPC Price" : 'Unit Price'}
              <span className="text-red-600">*</span>
            </h6>
            <div className="roValue cpm">
              <input
                type="number"
                name="sales_price"
                onChange={(e) => {
                  formik.handleChange(e);
                }}
                onBlur={formik.handleBlur}
                value={formik.values.sales_price}
                className="border_bottom !px-5"
              />
            </div>
            {formik.touched.sales_price && formik.errors.sales_price && (
              <span id="formikError" className="text-red-500 text-xs">
                {formik.errors.sales_price}
              </span>
            )}
          </div>
          {['Magazines', 'Stories', 'CPD'].includes(formik.values.campaign_type) && <div className="ind">
          <h6>
              {"quantity"}
              <span className="text-red-600">*</span>
            </h6>
            <div className="">
              <input
                type="number"
                name="quantity"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.quantity}
                className="border_bottom form-control"
              />
            </div>
            {formik.touched.quantity && formik.errors.quantity && (
              <span id="formikError" className="text-red-500 text-xs">
                {formik.errors.quantity}
              </span>
            )}
          </div>}
          <div className="ind">
            <h6>
              {"Budget"}
              <span className="text-red-600">*</span>
            </h6>
            <div className="roValue cpm">
              <input
                type="number"
                name="adunit_budget"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.adunit_budget}
                className="border_bottom"
              />
            </div>
            {formik.touched.adunit_budget && formik.errors.adunit_budget && (
              <span id="formikError" className="text-red-500 text-xs">
                {formik.errors.adunit_budget}
              </span>
            )}
            {formik.values.campaign_type === "CPM" &&
            formik.values.adunit_budget &&
            formik.values.sales_price ? (
              <p>
                Overall Impressions:{" "}
                {formik.values.adunit_budget ? (
                  <span>
                    {parseInt(
                      (formik.values.adunit_budget * 1000) /
                        formik.values.sales_price
                    )}
                  </span>
                ) : (
                  ""
                )}
              </p>
            ) : null}
             {formik.values.campaign_type === "CPC" &&
            formik.values.adunit_budget &&
            formik.values.sales_price ? (
              <p>
                Overall Clicks:{" "}
                {formik.values.adunit_budget ? (
                  <span>
                    {parseInt(
                      (formik.values.adunit_budget) /
                        formik.values.sales_price
                    )}
                  </span>
                ) : (
                  ""
                )}
              </p>
            ) : null}
          </div>
        </div>
      </div>
    </form>
  );
}

export default OrderDetails;


